import { Typography } from "@mui/material";
import React from "react";

export default function CoreH(props) {
  return <Typography variant={props.variant} component={props.component} {...props}>{props?.children}</Typography>;
}
